import React from "react";
import { motion } from "framer-motion";
export default function Intro() {
  return (
    <>
      <section className="hero">
        <div className="hero__bg">
          <img
            src={process.env.PUBLIC_URL + "/images/unga/redesign/unga-hero-bg.jpg"}
            alt="hero"
          />
        </div>
        <div className="auto__container">
          <div className="hero__inner">
            <motion.div
              animate={{
                opacity: [0, 1],
              }}
              transition={{ duration: 0.7, ease: "easeOut" }}
            >
              <div className="hero-container">
                <div className="hero-logos-img">
                  <img
                    className="img-fluid"
                    src={
                      process.env.PUBLIC_URL +
                      "/images/unga/redesign/hero-logos-all-3.png"
                    }
                    alt="Landmark Ventures, United Nations, Social Innovation Summit"
                  />
                </div>
                <h1 className="hero-title gilroy-font">
                  SOCIAL
                  <br />
                  INNOVATION
                  <br />
                  SUMMIT 2026
                </h1>
                <div className="hero-tagline gilroy-font">
                  @ UNGA / CLIMATE WEEK
                </div>
                <div className="hero-date-chip gilroy-font">
                  SEPTEMBER 21 - 24, 2026
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      <div className="under-hero-photos">
        <motion.div
          animate={{
            opacity: [0, 1],
          }}
          transition={{ duration: 1.2, ease: "easeOut" }}
        >
          <img
            className="img-fluid"
            src={
              process.env.PUBLIC_URL +
              "/images/unga/redesign/under-hero-photos.png"
            }
            alt="event photos"
          />
        </motion.div>
      </div>
      <div className="container narrower">
        <div className="cap-width">
          <div className="row hero-row-lower">
            <div className="col-12">
              <motion.div
                animate={{
                  x: [50, 0],
                  opacity: [0, 1],
                }}
                transition={{ duration: 1.2, ease: "easeOut" }}
              >
                <div className="header-text-container">
                  <div className="header-text">
                    Social Innovation Summit, along with our partners, are
                    delighted to host a series of VIP events for our network of
                    corporate responsibility executives, philanthropists,
                    investors, nonprofit leaders, policymakers, celebrity
                    activists, and social entrepreneurs across the global
                    impact ecosystem during UN General Assembly week 2026!
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
      <div className="section-divider flipped" />
    </>
  );
}
